import React from 'react';
import { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField } from '@mui/material';

interface AddStrategyModalProps {
    open: boolean;
    onClose: () => void;
    onAddStrategy: (strategyName: string) => Promise<void>;
}

const AddStrategyModal: React.FC<AddStrategyModalProps> = ({ open, onClose, onAddStrategy }) => {
    const [strategyName, setStrategyName] = useState('');
    
    const handleSubmit = async () => {
        if (strategyName) {
            try {
                await onAddStrategy(strategyName); // Wait for the mutation to complete
                setStrategyName(''); // Reset the input field
                onClose(); // Close the modal after the strategy is added
            } catch (error) {
                console.error("Error adding strategy:", error);
                // Optionally handle error feedback
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Add New Strategy</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Strategy Name"
                    fullWidth
                    variant="outlined"
                    value={strategyName}
                    onChange={(e) => setStrategyName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddStrategyModal;